import {
  BasicEmployeeInfo,
  BasicInfo,
  BasicUserInfo,
  EventVisibility,
  ReoccurrenceNth,
  ReoccurType,
  WeekDay,
} from '@seiri/shared/common'

export interface CreateEventForm {
  name: string
  activityId: string
  placeId: string
  capacity: number | null
  employeeIds: string[]
  /** A palette hex, or '' for "Podľa činnosti" - the activity's colour, sent as no colour. */
  color: string
  /** HTML from the editor, '' when there is none (then nothing is sent). */
  description: string
  visibility: EventVisibility
  customerGroupIds: string[]
  date: Date | null
  start: Date | null
  end: Date | null
  allDay: boolean
  allowWaitingList: boolean
  price: number | null
  /** Created closed to sign-up until the manager unlocks it; sent as `active: !locked`. */
  locked: boolean
  /** Minutes before the start a participant may cancel through their link; `-1` never, `0` until the start. */
  cancellationDeadline: number
  /** The public sign-up offers "Poznámka pre prevádzku"; a repeated event copies it to every termín. */
  allowCustomerNote: boolean
}

export interface CreateReoccuredEventForm extends CreateEventForm {
  /** "Názov série": the series' own name for managers; starts empty. */
  seriesName: string
  reoccurType: ReoccurType
  isReoccurNumOfTimes: boolean
  reoccurNumOfTimes: number | null
  reoccurFrom: Date
  reoccurUntil: Date | null
  weekdays: WeekDay[]
  weeks: ReoccurrenceNth[]
}

export interface ActivityItem {
  id: string
  name: string
  color: string
  compatiblePlaces: BasicInfo[]
  assignedEmployees: BasicEmployeeInfo[]
}

export enum EventType {
  ONETIMER = 'ONETIMER',
  REPEATED = 'REPEATED',
  COURSE = 'COURSE',
  RESERVATION = 'RESERVATION',
}

export interface PlaceItem {
  id: string
  name: string
  compatibleActivities: BasicInfo[]
  capacity: number
}

export interface EmployeeItem {
  id: string
  firstName: string
  lastName: string
  email: string
  phone: string
  user?: BasicUserInfo
}

export interface GroupItem {
  id: string
  name: string
}
